import React, { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import ChurchFinderMap from './ChurchFinderMap';
import ChurchDirectoryTable from './ChurchDirectoryTable';

type ChurchTab = 'map' | 'list';

const ChurchListPage: React.FC = () => {
  const [tab, setTab] = useState<ChurchTab>('map');

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        교회 찾기
      </Typography>

      <Tabs
        value={tab}
        onChange={(_event, value: ChurchTab) => setTab(value)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="지도" value="map" />
        <Tab label="목록" value="list" />
      </Tabs>

      {/*
        탭을 바꿔도 언마운트하지 않는다. naver 지도 인스턴스를 다시 만들면
        비싸고 화면이 깜빡인다. 대신 다시 보일 때 resize 를 한 번 쳐준다.
      */}
      <Box sx={{ display: tab === 'map' ? 'block' : 'none' }}>
        <ChurchFinderMap active={tab === 'map'} />
      </Box>

      <Box sx={{ display: tab === 'list' ? 'block' : 'none' }}>
        <ChurchDirectoryTable />
      </Box>
    </Container>
  );
};

export default ChurchListPage;
